import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const PhoneSettingsStyleParts = [
  'vStack1',
  'text1',
  'text2',
  'text3',
  'extensionsContainer',
  'parkingContainer',
  'speedDialContainer',
  'vStack2',
  'text4',
  'phoneSettingsWrapper',
  'subheadingSection',
] as const

const helpers = createMultiStyleConfigHelpers(PhoneSettingsStyleParts)

const { TextColor, BackgroundColor, DefaultBackgroundColor } =
  themeColorSectionKeys.Settings.PhoneSettings

export const PhoneSettingsStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    phoneSettingsWrapper: {
      width: '100%',
      height: '100%',
      padding: '1.875rem',
      flexDirection: 'column',
      gap: '1.25rem',
      overflowY: 'auto',
    },

    subheadingSection: {
      width: '100%',
      borderRadius: '0.25rem',
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0.75rem',
      gap: '0.62rem',
      backgroundColor: DefaultBackgroundColor,
    },

    vStack1: {
      w: 'full',
      gap: '1rem',
    },

    text1: {
      textStyle: 'Body2_Bold',
    },

    text2: {
      textStyle: 'Body2',
    },

    text3: {
      textStyle: 'Body3_Bold',
    },

    extensionsContainer: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: '2.5rem',
      borderRadius: '0.5rem',
      border: '1.5px solid #B4B4CC',
      backgroundColor: BackgroundColor,
      paddingX: '12px',
      gap: '0.62rem',
    },
    parkingContainer: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: '2.5rem',
      borderRadius: '0.5rem',
      border: '1.5px solid #B4B4CC',
      backgroundColor: BackgroundColor,
      paddingX: '12px',
      gap: '0.62rem',
    },
    speedDialContainer: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: '62px',
      borderRadius: '0.5rem',
      border: '1.5px solid #B4B4CC',
      backgroundColor: BackgroundColor,
      padding: '12px',
      gap: '0.62rem',
    },
    vStack2: {
      w: 'full',
      gap: '1.75rem',
    },

    text4: {
      textStyle: 'Body2',
      color: TextColor,
    },
  },
})

export const usePhoneSettingsStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof PhoneSettingsStyleParts>(
    getName({ PhoneSettingsStyles }),
    props,
  )
}
